export interface ICommunicationKeyParams {
  applicationID: string | undefined;
}

export const communicationKeys = {
  root: (params: ICommunicationKeyParams) =>
    ['communication', params.applicationID] as const,
  comments: (params: ICommunicationKeyParams) =>
    [...communicationKeys.root(params), 'comments'] as const,
  emails: (params: ICommunicationKeyParams) =>
    [...communicationKeys.root(params), 'emails'] as const,
  orttoEmails: (params: ICommunicationKeyParams) =>
    [...communicationKeys.root(params), 'orttoEmails'] as const,
  userComments: (params: ICommunicationKeyParams) =>
    [...communicationKeys.root(params), 'userComments'] as const,
};

export function parseCommunicationKey<T extends keyof typeof communicationKeys>(
  queryKey: ReturnType<(typeof communicationKeys)[T]>
) {
  const [, applicationID] = queryKey;
  return { applicationID };
}
